import { useState, useEffect } from 'react'
import { isAndroidApp, isWeb, getPlatform, getApiBaseUrl } from '../utils/platform'

/**
 * Hook React pour détecter et utiliser la plateforme actuelle
 * @returns {object} Objet contenant les informations sur la plateforme
 */
export function usePlatform() {
  const [platform, setPlatform] = useState(getPlatform())
  const [isAndroid, setIsAndroid] = useState(isAndroidApp())
  const [isWebPlatform, setIsWebPlatform] = useState(isWeb())
  const [apiBaseUrl, setApiBaseUrl] = useState(getApiBaseUrl())

  useEffect(() => {
    // Mettre à jour les valeurs au montage du composant
    setPlatform(getPlatform())
    setIsAndroid(isAndroidApp())
    setIsWebPlatform(isWeb())
    setApiBaseUrl(getApiBaseUrl())
  }, [])

  return {
    platform,        // 'android' | 'web'
    isAndroid,       // boolean
    isWeb: isWebPlatform,  // boolean
    apiBaseUrl,      // string - URL de base de l'API
  }
}

